module.exports = __webpack_public_path__ + "static/media/wireframes_UnregelApp.0bc4492c.jpeg";